// 客户管理相关
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi, userAccountApi, ffxApi} = apiPrefix;

// 投诉客户详情-详情信息
export const getComplaintDetail = (params) => get(baseApi + '/complaint/customerDetail', params);
// 投诉客户详情-发送短信
export const sendSms = (params) => get(baseApi + '/complaint/sendSms', params);
// 投诉客户详情-下发列表
export const getAssgnRecordList = (params) => get(baseApi + '/complaint/customerRecord', params);
// 投诉客户详情-通话记录列表
export const getTelephoneRecordList = (params) => {
  if (params.pageOrigin === 'workOrderDetail') return get(baseApi + '/callRecord/get', params);
  return get(baseApi + '/complaint/callRecord', params);
}
// 投诉客户详情-撞库记录列表
export const getCollisionRecordList = (params) => get(baseApi + '/complaint/collisionWarehouse', params);
// 投诉客户详情-短信记录列表
export const getSmsRecordList = (params) => get(baseApi + '/complaint/smsRecord', params);
// 投诉客户详情-赠险保单列表
export const getZxPolicyList = (params) => post(baseApi + '/policy/resp_record', params);
// 投诉客户详情-付费险保单列表
export const getFfxPolicyList = (params) => post(baseApi + '/policy/ffx_record', params);
// 投诉客户详情-获取付费险保单下载链接
export const getFfxPolicyDownUrl = (params) => get(baseApi + '/policy/electronicPolicyUrl', params);
// 投诉客户详情-保单记录-是否能导出保单退款说明
export const canExportComplaintExplanation = (params) => post(baseApi + '/policy/can_export_complaint_statement', params);
// 投诉客户详情-保单记录-导出保单退款说明
export const exportComplaintExplanation = (params) => post(baseApi + '/policy/export_complaint_statement', params, {responseType: 'blob'});
// 投诉客户详情-付费险保单缴费列表
export const getFfxPolicyPayRecordList = (params) => post(baseApi + '/policy/charge_record', params);
// 投诉客户详情-付费险保单退费列表
export const getFfxPolicyRefundRecordList = (params) => post(baseApi + '/policy/refund_record', params);
// 投诉客户详情-退费期次选项
// export const getRefundIssueOptions = (params) => get(baseApi + '/policy/getIssue', params);
export const getRefundIssueOptions = (params) => post(apiPrefix.ffxApi + '/return_price/query', params);

// 投诉客户详情-退全部保费、退指定期次保费、仅退费
export const policyRefundAll = (params) => post(apiPrefix.ffxApi + '/return_price/save', params);
// 查询退费记录
export const refundPriceQuery = (params) => post(apiPrefix.ffxApi + '/return_price/query', params);
// 投诉客户详情-退指定期次保费
// export const policyRefundIssue = (params) => post(apiPrefix.ffxApi + '/return_price/add', params);
// 投诉客户详情-付费险保单签约解约列表
export const getFfxPolicyResignRecordList = (params) => post(baseApi + '/policy/sign_record', params);
// 投诉客户详情-付费险保单解约
export const ffxPolicyRemoveSign = (params) => post(baseApi + '/policy/policy_refund', params);
// 投诉客户详情-付费险保单恢复签约
export const ffxPolicyRecoverSign = (params) => post(baseApi + '/policy/recoverSignPolicy', params);
// 投诉客户详情 -付费险撤回退费
export const ffxPolicyCancelRefund = (params) => get(ffxApi + '/return_price/revoke', params);
// 投诉客户详情-取消升级
export const policyCancelUpgrade = (params) => post(`${apiPrefix.ffxApi}/return_price/delPolicyUpgrade`, params);
// 投诉客户详情 - 发送营销短险
export const policySendMarketingSms = (params) => get(userAccountApi + '/marketingSms/send', params);
// 投诉客户详情-可回溯记录列表
export const getTraceList = (params) => post(baseApi + '/backtrack/list', params);
// 扣款记录查询
export const getCardNoList = (params) => post(baseApi + '/complaint/queryByCardNo', params);
// 用户视图与行为时间链 —— 通用单客户时间链查询
// 契约依据：《用户归一与行为时间链-查询链路设计-v0.1.md》§6（2026-09-16 定稿，09-18 补 degradedDomains）
//   路径 / 方法：POST /query/chain/timeline（本模块部署在 wisdom-cloud 内，故续接 baseApi 前缀）
//   入参 AnchorQueryRequest：customerId / md5Phone / phone / systemId 任一即可
//   出参 Response<TimelineResultDTO>
//       ⚠️ 出参含 degradedDomains[]（09-18 新增）：本次因数据源不可用而置空的事件域，
//          每项 { domain, domainName, domainGroup, retryAfterSeconds }，**始终为数组**。
//          判「有没有降级」请看它，**不要**看 events 是否为空 —— 全部域降级时 events 也是空的。
// 说明：该接口不限投诉场景，是通用用户时间链查询，故不再挂在 /complaint 下。
export const getUserTimeline = (params) => post(baseApi + '/query/chain/timeline', params);

// 用户信息（块①）—— 属性 / 身份标识 / 派生属性，**不含事件**（2026-10-09 两块拆分）
//   路径 / 方法：POST /query/chain/profile（入参与 /timeline 完全一致：AnchorQueryRequest 四选一）
//   出参 Response<UserProfileResultDTO>：{ anchor, profile, identities[], derived }
//   为什么要拆：/timeline 的段③派发要跨 9 个域、串行打 MySQL + 两个 ClickHouse 端点，
//              重客户实测 5.6s ⇒ 首屏连「这个客户是谁」都渲染不出来。
//              本接口只走段①找人 + 段②找键 + 锚表，毫秒级，页面先把用户信息立起来。
//   ⚠️ 出参里的 `derived.domainCnt` **恒为 0**（本块没有事件可数），域数一律以 /timeline 为准。
//   ⚠️ 出参不含 events / degradedDomains / hasDialog —— 这些语义只在事件链上成立。
export const getUserProfile = (params) => post(baseApi + '/query/chain/profile', params);

// 企微聊天记录明细 ——「看对话」抽屉的数据源（2026-09-18 新增）
//   路径 / 方法：POST /query/chain/qwx/messages
//   入参 AnchorQueryRequest（本抽屉只传 customerId）
//   出参 Response<QwxMessageListDTO>：{ customerId, total, messages[] }
//       messages 项：{ bizId, bindingId, direction(1=我方/2=客户), contentType, content, msgTime }
//   ⚠️ 与时间链分开的原因：抽屉是**点开才拉**的惰性加载，整段聊天正文不进时间链响应。
//   ⚠️ `direction` 直出后端 `msg_type` 原值，前端据此分左右两侧，**不要在前端再猜方向**。
//   ⚠️ `content` 为**原样**（图片/链接类消息的内容就是 URL 本身，当前口径为原样展示）。
export const getQwxMessages = (params) => post(baseApi + '/query/chain/qwx/messages', params);

/**
 * 工单备注明细（「看备注」抽屉，2026-09-20 新增）
 * @param {*} params.customerId  归一锚 customer_id（**必填**，用于校验工单归属）
 * @param {*} params.jobOrderId  工单主键（**必填**，= 时间链事件行上的 bizId）
 *
 *   出参 data：{ jobOrderId, progressStatus, result, resultText, processType, processTypeText,
 *               remark, complaintContent, closeTime, operatorName, submitCount }
 *   其中 remark 是备注主体（varchar(500)，实测最长 343）⇒ **全文展示、不截断**；
 *   complaintContent 只是短标签（实测 93.2% 为空），有值才展示。
 *
 *   ⚠️ 两个入参缺一不可 —— 只给 jobOrderId 时任意 id 都能取到数据（越权口子），
 *      后端会直接以 PARAM_MISSING 拒绝（见 JobOrderDetailRequest）。
 *   ⚠️ 与企微抽屉（按 customerId 拉整段对话）不同：本接口取的是**单条工单**，入参形态独立。
 */
export const getJobOrderDetail = (params) => post(baseApi + '/query/chain/jobOrder/detail', params);


/**
 * 用户特征分析（「智能分析」抽屉）
 *   路径 / 方法：POST /query/chain/analysis
 *   入参：锚点四选一（customerId / md5Phone / phone / systemId 任一即可）+ force（可选）
 *       force=true 跳过当日缓存、重调 LLM、原子替换旧行（后端 compute-then-replace，
 *       重跑失败旧结果仍在 ⇒ 前端不需要二次确认）。
 *   出参 Response<AnalysisResultDTO>：
 *       { profileSummary, riskLevel(HIGH/MEDIUM/LOW), riskAssessment, serviceStrategy,
 *         keySignals[], degraded, promptVersion, dialogCount, analysisDate }
 *   ⚠️ degraded=true 是 **200 正常返回**：LLM 不可用、后端回落规则层信号拼装，
 *      前端须渲染成「降级横幅 + 结果」，**不能**当失败态（否则坐席会把
 *      「系统挂了」误读成「分析完了，风险不高」）。
 *   ⚠️ 该接口读超时较长（Apollo read-ms=60000，现场跑 LLM 约 30~60s），调用方不要设短超时。
 */
/**
 * 智能分析·发起（force）。**唯一带慢路径 LLM 的接口 ⇒ 单独放宽超时**：
 * 全局实例是 60s（src/api/base/request.js），而后端单次 LLM 实测可到 79s、且内部还会重试一次，
 * 沿用 60s 会让坐席看到「分析超时」而后端其实仍在跑并成功落库（2026-10-14 测试环境实测）。
 * 这里给 300s 覆盖「两次尝试 × 单次 120s」的最坏情况；根治方案是改成异步任务 + 轮询（需另行设计）。
 */
export const analyzeUser = (params) => post(baseApi + '/query/chain/analysis', params, { timeout: 300000 });

/**
 * 当日分析结果存在性探测（「查看分析」判据）
 *   路径 / 方法：POST /query/chain/analysis/status（只读 DB，不触 LLM，毫秒级）
 *   出参 data: { customerId, exists, degraded, analysisDate, promptVersion, dialogCount }
 *   用途：查看模式先探测，当日无行 ⇒ 直接空态引导「发起分析」，不发会触发生成的 POST。
 */
export const analyzeUserStatus = (params) => post(baseApi + '/query/chain/analysis/status', params);


/**
 * 投诉工单管理-筛选选项枚举
 * @param {*} params.type
 *     1. 业务渠道：businessChannel
 *     2. 投诉来源：complaintSource
 *     3. 投诉处理结果：result
 *     4. 数据反馈方：dataFeedback
 *     5. 结案等级：closeLevel
 *     6. 投诉类型：complaintType
 *     7. 产品Code：code
 *     8. 链路： jobOrderLink
 */
export const getWorkOrderOptions = (params) => get(baseApi + '/jobOrder/getComplaintEnum', params);
// 投诉工单管理-来源位置选项
export const getTsPositionOptions = (params) => get(baseApi + '/jobOrder/getPosition', params);

export const batchClaim = (params) => post(baseApi + '/jobOrder/batchClaim', params);

export const getCustomerInfo = (params) => get(baseApi + '/jobOrder/getCustomerInfo', params);
// 投诉工单管理-获取可被指派人员列表
export const getBeAssignUserOptions = (params) => get(baseApi + '/jobOrder/seatList', params);
// 投诉工单管理-工单列表
export const getWorkOrderList = (params) => post(baseApi + '/jobOrder/list', params);
// 投诉工单管理-工单导出
export const exportWorkOrder = (params) => {
  return post(apiPrefix.baseApi + "/jobOrder/downLoad", params, {
    responseType: "blob",
  });
}
// 投诉工单管理-工单添加、修改
export const addWorkOrder = (params) => post(baseApi + '/jobOrder/save', params);
// 投诉工单管理-工单状态变更
export const changeWorkOrder = (params) => post(baseApi + '/jobOrder/change', params);
// 投诉工单管理-保单信息带出
export const getWorkOrderPolicyInfo = (params) => get(baseApi + '/jobOrder/policyInfo', params);
// 投诉工单管理-工单日志列表
export const getWorkOrderLogList = (params) => get(baseApi + '/jobOrder/listLog', params);
// 投诉工单管理-工单语音导航对话列表
export const getOrderVoiceNavigationList = (params) => get(baseApi + '/jobOrder/getOrderVoiceNavigation', params);
// 投诉工单管理-工单保单列表
export const getWorkOrderPolicyList = (params) => get(baseApi + '/jobOrder/policy/list', params);
// 投诉工单管理-工单保单扣费记录列表
export const getWorkOrderPolicyChargeRecordList = (params) => get(baseApi + '/jobOrder/policy/deductionRecord', params);
// 投诉工单管理-投诉列表
export const getWorkOrderCompliantList = (params) => post(baseApi + '/jobOrder/compliantDetail', params);
// 投诉工单管理-是否能拨打
export const canCallCheck = (params) => post(baseApi + '/jobOrder/callCheck', params);
// 投诉工单管理-工单数据统计
export const getWorkOrderStats = (params) => get(baseApi + '/jobOrder/statistics', params);
// 投诉工单管理-未接短信发送
export const sendSmsToNoAccept = (params) => post(`${baseApi}/jobOrder/sendSms`, params);
// 投诉工单管理-复效
export const recoverOrderFromTimeout = (params) => post(`${baseApi}/jobOrder/remodelJobOrderStatus`, params);
// 获取号码来电次数
export const getCallInCount = (params) => get(`${baseApi}/jobOrder/getCallInCount`, params);
// 投诉工单管理-通话记录上报
export const updateCallRecord = (params) => post(`${baseApi}/callRecord/update`, params);


// 黑名单管理-列表
export const getBlackList = (params) => get(baseApi + '/blackPhoneNew/selectByPhone', params);
// 黑名单管理-模板下载
export const blackTemplateDown = (params) => {
  return get(baseApi + "/blackPhoneNew/download/excel/template", params, {responseType: "blob"});
}
// 黑名单管理-excel上传数据
export const blackExcelUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });
  return post(baseApi + "/blackPhoneNew/upload/excel", data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
// 黑名单管理-批量新增
export const blackBatchAdd = (params) => post(baseApi + '/blackPhoneNew/insertBatch', params);
// 黑名单管理-删除
export const blackBachDelete = (params) => post(baseApi + '/blackPhoneNew/delete', params);





// 敏感信息转码
export const sensitiveDataOperate = (params) => post(baseApi + '/data/sensitiveDataOperation', params);
// 天天有保业务系统合规档案系统 上传保单
export const businessArchivesAnalysis = (params) => {
    const data = new FormData();
    Object.keys(params).forEach((item) => {
        data.append(item, params[item]);
    });
    return post(baseApi + "/businessArchives/analysis", data, {
        headers: {"Contennt-Type": "multipart/form-data",},
        noValid: true,
    });
}
// 列表
export const businessArchivesQueryList = (params) => post(baseApi + '/businessArchives/queryList', params);
// 3. 详情
export const businessArchivesDetail = (params) => get(baseApi + '/businessArchives/detail', params);
// 删除
export const businessArchivesDelete = (params) => post(baseApi + '/businessArchives/delete', params, {noValid: true});
// 修改
export const businessArchivesModify = (params) => post(baseApi + '/businessArchives/modify', params);

export const queryReport = (params) => post(baseApi + '/policyMonitor/queryReport', params);

export const policyIncome = (params) => post(baseApi + '/monitorReport/policyIncome', params);

export const getInsuranceProduct = (params) => get(baseApi + '/common/insuranceProduct', params);
export const getPayWay = (params) => get(baseApi + '/common/payWay', params);
export const getBrokerCompany = (params) => get(baseApi + '/common/brokerCompany', params);
export const getCompany = (params) => get(baseApi + '/common/company', params);




// 企微消息 - 获取签到状态
export const getQwClockIn = (params) => get(`${baseApi}/qywxChat/checkWorkHour`, params);
// 企微消息 - 签到状态变更
export const qwClockInUpdate = (params) => post(`${baseApi}/qywxChat/workHour`, params);
// 企微消息 - 获取企微用户列表
export const getQwChatUserList = (params) => post(`${baseApi}/qywxChat/queryChatHistory`, params);
// 企微消息 - 获取线下退费用户列表
export const getQwOfflineRefundUserList = (params) => {
  const {status, ...restParams} = params;
  let link = baseApi;
  if (status === 1){
    link += '/refundManage/notAddAywx';
  } else if (status === 2){
    link += '/refundManage/addAywx';
  } else if (status === 3){
    link += '/refundManage/uploadFileUser';
  } else if (status === 4){
    link += '/refundManage/refundSuccess';
  }
  return post(link, restParams);
}
// 企微消息 - 线下退费 - 用户列表 - 导出
export const qwOfflineRefundUserExport = (params) => post(`${baseApi}/refundManage/exportUser`, params, {responseType: "blob"});

/**
 * 企微消息 - 获取聊天列表 / 聊天被占用情况
 *
 * @returns
 * msgType 消息类型 1 坐席发送  2 客户发送
 * msgContentType 消息内容类型：1 文字；2 图文链接；3 图片 ；4 视频； 5语音 ；6 文件；7 好友名片；8 小程序；11 视频号消息；12 视频号直播消息；13 地理位置消息；14 转发的聊天记录；15 音视频通话消息； 10000：系统消息
 * msgTime 消息发送时间
 * msgContent 消息内容
 * href 发送内容未图文链接时，链接地址
 * title 发送内容未图文链接时，链接标题
 * contentDesc 发送内容未图文链接时，链接描述
 */
export const getQwChatList = (params) => post(`${baseApi}/qywxChat/queryChatDetails`, params);

/**
 * 企微消息 - 发送聊天消息
 *
 * @param {string} talkWeixinInfoId 聊天id
 * @param {boolean} msgType 消息类型 1 文字 2图文 3 图片
 * @param {string} msgContent 消息内容
 * @param {string} href 发送内容为图文链接时，链接地址
 * @param {string} title 发送内容为图文链接时，链接标题
 * @param {string} desc 发送内容为图文链接时，链接描述
 *
 */
export const sendQwChatMsg = (params) => post(`${baseApi}/qywxChat/sendQywxMsg`, params);
// 企微消息 - 发送图文卡片 (后台直接发送，不需要把相关信息返回给前端，前端再调发送聊天消息接口发送)
export const sendQwChatImgLinkCard = (params) => post(`${baseApi}/refundManage/sendCard`, params);
// 企微消息 - 聊天消息撤回
export const qwChatRecall = (params) => get(`${baseApi}/qywxChat/recalledMsg`, params);
// 企微消息 - 聊天上传图片
export const qwChatUploadImg = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });
  return post(baseApi + "/qywxChat/uploadImg", data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}
// 企微消息 - 获取聊天快捷发送图文链接的卡片列表
export const getQwCartMsgList = (params) => get(`${baseApi}/qywxChat/cartMsgList`, params);
// 企微消息 - 标星状态变更
export const qwChatMarkUpdate = (params) => post(`${baseApi}/qywxChat/updateChatMark`, params);
// 企微消息 - 线下退费客户 - 用户已接受退款成功金额
export const acceptRefundSuccess = (params) => post(`${baseApi}/refundManage/closeRefund`, params);

// 企微消息 - 获取快捷回复列表
export const getQwQuickReplyList = (params) => post(`${baseApi}/qywxChat/quickReply`, params);
// 企微消息 - 获取快捷回复类别选项列表
export const getQwQuickReplyTypeOptions = (params) => post(`${baseApi}/qywxChat/quickReply`, params);

// 企微消息 - 投诉客户 - 转给客服
export const transferJobToAgent = (params) => get(`${baseApi}/qywxChat/transferJobToAgent`, params);
// 企微消息 - 投诉客户 - 工单列表
export const getQwComplaintList = (params) => post(`${baseApi}/qywxChat/getQwComplaintList`, params);
// 企微消息 - 投诉客户 - 处理工单
export const updateQwResult = (params) => get(`${baseApi}/qywxChat/updateQwResult`, params);

// 企微消息 - 获取线下退费的保单详情
export const getOfflineRefundPolicy = (params) => post(`${baseApi}/refundManage/refundPolicy`, params);





// 退款失败用户 - 列表
export const getOfflineRefundList = (params) => post(`${baseApi}/offlineRefund/list`, params);
// 退款失败用户 - 列表导出
export const exportOfflineRefundList = (params) => {
  return post(`${baseApi}/offlineRefund/list`, params, {
    responseType: "blob",
  });
}
// 退款失败用户-飞书审批用户导入
export const updateFsspRefundUser = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(`${baseApi}/offlineRefund/uploadPaymentInfo`, data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}

// 退款失败用户 - 获取客户详情
// export const getCustomerDetail = (params) => post(`${baseApi}/offlineRefund/queryCustomer`, params);
// 退款失败用户 - 获取保单退费期次详情
// export const getPolicyIssueDetail = (params) => post(`${baseApi}/offlineRefund/queryRefundable`, params);
// 退款失败用户 - 查询可退费数据 (新增时用)
export const queryOfflineRefundCustomer = (params) => post(`${baseApi}/offlineRefund/queryCustomerAndList`, params);
// 退款失败用户 - 获取线下退费详情 (查看、编辑时用)
export const getOfflineRefundDetail = (params) => post(`${baseApi}/offlineRefund/detail/${params.id}`);
// 退款失败用户 - 新增
export const offlineRefundAdd = (params) => {
  if (params.id){
    return post(`${baseApi}/offlineRefund/update`, params);
  } else {
    return post(`${baseApi}/offlineRefund/add`, params);
  }
}

// 退款失败用户 - 企微消息 - 发送图文卡片 (后台直接发送，不需要把相关信息返回给前端，前端再调发送聊天消息接口发送)
export const orSendQwChatImgLinkCard = (params) => post(`${baseApi}/offlineRefund/sendCardMsg`, params);
// 退款失败用户 - 查询微信用户列表
export const queryOfflineRefundWxUserList = (params) => post(`${baseApi}/offlineRefund/queryAddedQywxUsers`, params);
// 退款失败用户 - 绑定微信用户
export const bindOfflineRefundWxUser = (params) => get(`${baseApi}/offlineRefund/bindQywxCustomer`, params);
